import { render, staticRenderFns } from "./JGraphicCode.vue?vue&type=template&id=9835d22a&scoped=true&"
import script from "./JGraphicCode.vue?vue&type=script&lang=js&"
export * from "./JGraphicCode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9835d22a",
  null
  
)

export default component.exports